import { createFileRoute, redirect } from "@tanstack/react-router";

const SLUG = "3-most-common-skylight-problems-that-cause-roof-leaks-in-phoenix";

export const Route = createFileRoute("/3-most-common-skylight-problems-that-cause-roof-leaks-in-phoenix")({
  beforeLoad: () => {
    throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 });
  },
});
